function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import classNames from 'classnames';
import React, { useState, createContext, useContext, useEffect, forwardRef, useImperativeHandle } from 'react';
import Trigger from './Trigger';
import { addClass, removeClass } from '../../common/utils/dom';
import './index.scss';
const FullScreenContext = /*#__PURE__*/createContext(null);
export const useFullScreen = () => useContext(FullScreenContext);
//@ts-ignore
const FullScreen = /*#__PURE__*/forwardRef(({
  autoFullScreen,
  children,
  className,
  classNameFullScreen,
  classNameNotFullScreen,
  zIndex,
  ...props
}, ref) => {
  const state = useState(autoFullScreen);
  const [isFullscreen, setFullscreen] = state;
  useImperativeHandle(ref, () => {
    const requestFullscreen = () => {
      if (!isFullscreen) {
        document.documentElement.requestFullscreen = document.documentElement?.webkitRequestFullscreen || document.documentElement.requestFullscreen;
        document.documentElement.requestFullscreen();
      }
    };

    const exitFullscreen = () => {
      if (isFullscreen) {
        document.exitFullscreen = document.webkitExitFullscreen || document.exitFullscreen;
        document.exitFullscreen();
      }
    };

    return {
      isFullscreen,
      requestFullscreen,
      exitFullscreen,
      toggle: () => {
        if (isFullscreen) {
          exitFullscreen();
        } else {
          requestFullscreen();
        }
      }
    };
  }, [isFullscreen]);
  useEffect(() => {
    const handleChangeFullScreen = _event => {
      const value = !!(document.fullscreenElement || document.webkitFullscreenElement);
      setFullscreen(value);

      if (value) {
        addClass(document.body, 'is-fullscreen');
      } else {
        removeClass(document.body, 'is-fullscreen');
      }
    }; // for safari


    const webkit = document.webkitExitFullscreen ? 'webkit' : '';
    document.addEventListener(`${webkit}fullscreenchange`, handleChangeFullScreen);
    return () => {
      document.removeEventListener(`${webkit}fullscreenchange`, handleChangeFullScreen);
    };
  }, []);
  return /*#__PURE__*/React.createElement(FullScreenContext.Provider, {
    value: state
  }, /*#__PURE__*/React.createElement("div", _extends({
    className: classNames('fullscreen-trigger', {
      'is-fullscreen': isFullscreen,
      'high-index': zIndex === 'high',
      'higher-index': zIndex === 'higher'
    }, className, isFullscreen ? classNameFullScreen : classNameNotFullScreen)
  }, props), children));
});
FullScreen.Trigger = Trigger;
FullScreen.defaultProps = {
  autoFullScreen: false
};
export default FullScreen;